import { z } from "zod";
import { membershipChannelSchema } from "@/shared/membership/directory.schema";

export const updateMembershipPrefsSchema = z
  .object({
    channel: membershipChannelSchema.optional(),
    isPulseActive: z.boolean().optional(),
  })
  .strict();
export type UpdateMembershipPrefsInput = z.infer<typeof updateMembershipPrefsSchema>;

export const updateMembershipPrefsResponseSchema = z.object({
  membershipId: z.string(),
  channel: membershipChannelSchema,
  isPulseActive: z.boolean(),
  version: z.number().int(),
});
export type UpdateMembershipPrefsResponse = z.infer<typeof updateMembershipPrefsResponseSchema>;
